<template>
  <div>
    <VipForm ref='form' @success="getList"/>
    <BasicTable
      hiddenFooter
      hasOperate
      :border="false"
      customClass="table"
      :tableData="tableData"
      :treeProps="{ children: 'sub', hasChildren: 'hasChildren' }"
      :columns="columns">
      <template slot="tableOpeate">
      会员等级&emsp;
      <AppButton size="small" type="primary" plain @click="addVipGrade"><i class="fa fa-plus fa-lg icon" ></i>新增</AppButton>&emsp;
      </template>
      <template v-slot:operate="{ item }">
        <AppButton type="primary" plain size="small" @click="editVipGeade(item)"><i class="fa fa-edit fa-lg icon" ></i>编辑</AppButton>
        <AppButton type="primary" plain size="small" @click="deleteItem(item)"><i class="fa fa-edit fa-lg icon" ></i>删除</AppButton>
      </template>
    </BasicTable>
  </div>
</template>

<script>
import { VipGradeService } from '../../service/vipGrade.service';
import VipForm from './formVipGrade.vue';
import { MessageBox } from 'element-ui';
const columns = [
  { name: '等级编号', key: 'level_id' },
  { name: '等级名称', key: 'level_name'},
  { name: '消费额度', key: 'amount'},
  { name: '优惠折扣', key: 'discount' },
  { name: '等级积描述', key: 'describe' },
  { name: '操作', key: 'operate', type: 'custom', width: '300px'}
];
  export default {
    name: 'vipGrade',
    components: { VipForm },
    data() {
      return {
        columns,
        tableData: [],
      }
    },
    created() {
      this.getList();
    },
    methods: {
      async getList() {
        const data = await VipGradeService.getList();
        this.tableData = data;
      },
      addVipGrade() {
        this.$refs.form.open('add');
      },
      deleteItem(data) {
        MessageBox.confirm('确定要删除这条这个品牌吗？', '删除品牌').then(async () => {
          await VipGradeService.operate('del', data);
          this.getList();
        });
      },
      editVipGeade(data) {
        this.$refs.form.open('edit', data);
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>